import { ProductCard } from "components";
import { ProductServices } from "services";

const LATEST_ADDITIONS_GRID_CONFIG = {
  containerSpacing: 1,
  rowDivisions: 3,
  renderComponent: (value, { onAddToWishlist }) => (
    <ProductCard
      product={value}
      handleAddToWishlist={(ev) => {
        ev.stopPropagation();
        onAddToWishlist(value);
      }}
    />
  ),
  fetchListData: ProductServices.getProductsList,
  emptyDataContent: () => null,
};

export default LATEST_ADDITIONS_GRID_CONFIG;
